<template>
  <div>
    <div class="widget-body">
      <div class="object-list table-responsive">
        <div class="col-md-12">
          <div class="row">
            <table class="table table-striped first-td-padding" style="table-layout: auto; width: 100%;">
              <thead>
                <tr>
                  <th v-if="listDefinition.multiSelect && policy.can('edit')" width="7%">
                    <input type="checkbox" v-on:change="multiSelectAll" style="margin: 0; vertical-align: middle">
                    <span v-if="multiSelectCount > 0" style="font-size:.8em;">{{ multiSelectCount }} items</span>
                  </th>
                  <th v-for="field in tableFields"
                    :class="{ active: sortKey == field.name }" v-if="field[$mq]">
                    <span @click="sortBy(field.name)" class="hover-text" style="font-size:.8em;">{{ field.title }}</span>
                    <span @click="sortBy(field.name)" class="hover-text arrow" :class="sortOrders[field.name] > 0 ? 'asc' : 'dsc'">
                    </span>
                    <i class="fa fa-filter" @click="showModal(field.name)" v-if="listDefinition.filter && !field.noFilter" />
                    <modal :small="true" :ref="field.name" :cancelClass="'none'" :okAction="ok" :okText="'Filter'" v-if="field.type === 'list' && listDefinition.filter && !field.noFilter">
                      <div slot="title">{{field.title}}</div>
                      <div>
                        <table class="modal-table" style="table-layout: auto; width: 100%;">
                          <tbody>
                            <tr>
                              <td>Options</td>
                              <td>
                                <vuestic-simple-select :noPadding="true"
                                  v-model="search[field.name]"
                                  v-bind:options="field.options">
                                </vuestic-simple-select>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </modal>
                    <modal :small="true" :ref="field.name" :cancelClass="'none'" :okAction="ok" :okText="'Filter'" v-else-if="field.type === 'range' && listDefinition.filter && !field.noFilter">
                      <div slot="title">{{field.title}}</div>
                      <div>
                        <table class="modal-table" style="table-layout: auto; width: 100%;">
                          <tbody>
                            <tr>
                              <td>Options</td>
                              <td>
                                <vuestic-simple-select :noPadding="true"
                                  v-model="option[field.name]"
                                  v-bind:options="rangeOptions">
                                </vuestic-simple-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Value</td>
                              <td>
                                <span class="input-group">
                                  <input
                                    :name="field.name"
                                    v-model="search[field.name]"
                                    class="filter-input"
                                    />
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </modal>
                    <modal :small="true" :ref="field.name" :cancelClass="'none'" :okAction="ok" :okText="'Filter'" v-else-if="field.type === 'text' && listDefinition.filter && !field.noFilter">
                      <div slot="title">{{field.title}}</div>
                      <div>
                        <table class="modal-table" style="table-layout: auto; width: 100%;">
                          <tbody>
                            <tr>
                              <td>Options</td>
                              <td>
                                <vuestic-simple-select :noPadding="true"
                                  v-model="option[field.name]"
                                  v-bind:options="textOptions">
                                </vuestic-simple-select>
                              </td>
                            </tr>
                            <tr>
                              <td>Value</td>
                              <td>
                                <span class="input-group">
                                  <input
                                    :name="field.name"
                                    v-model="search[field.name]"
                                    class="filter-input"
                                    />
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </modal>
                  </th>
                  <th width="2%">
                  </th>
                  <th width="2%" v-if="policy.can('remove')">
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="rows" v-for="(data, i) in displayData">
                  <td v-if="listDefinition.multiSelect && policy.can('edit')">
                    <input type="checkbox" v-on:change="multiSelectChange" v-model="multiSelect[data.index]" style="margin: 0; vertical-align: middle">
                  </td>
                  <td v-for="field in tableFields" v-if="field[$mq]">
                    <span v-if="field.type === 'text' && field.link">{{ data[field.name] }}</span>
                    <span v-if="field.type === 'dummy' && field.link">{{field.key}}</span>
                    <span v-else-if="field.type === 'list'">{{ data[field.name] }}</span>
                    <span v-else-if="field.type === 'text' && !field.link">{{ data[field.name] }}</span>
                    <span v-else-if="field.type === 'range'">{{ data[field.name] }}</span>
                    <span v-else-if="field.type === 'date'">{{ data[field.name] | formatDate }}</span>
                    <span v-else-if="field.type === 'boolean'"><span v-if="data[field.name]">Yes</span><span v-else>No</span></span>
                    <span v-else-if="field.type === 'length'">{{ data[field.name].length }}</span>
                    <span v-else-if="field.type === 'audio'">
                      <audio controls>
                        <source :src="data[field.name]" type="audio/wav">
                      </audio>
                    </span>
                  </td>
                  <td v-if="policy.can('edit') && objectEdit">
                    <router-link v-for="link in tableLinks" :key="link.name" :to="{ name: link.path, params: { id: data[link.name] }}">
                      <img src="static/icons/actions/edit-32.png" style="height: 1.5em;" />
                    </router-link>
                  </td>
                  <td v-if="policy.can('remove') && objectDelete">
                    <img src="static/icons/actions/trash-32.png" style="cursor: pointer; height: 1.5em;" @click="remove(data.id, data[list_urls.deleteObject.message])" />
                  </td>
                </tr>
                <tr v-if="!rows">
                  <td :colspan="tableFields.length + 1" style="text-align: center;">Nothing to show here</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- Table Pagination Component -->
          <table-pagination v-if="filteredData.length > 25"
            :filteredData = "filteredData"
            :pageNo = "pageNo"
            :perPage = "perPage"
            :perPageChange = "perPageChange"
            :onChangePage = "onChangePage"
            :onNextPage = "onNextPage"
            :onPreviousPage = "onPreviousPage"
            :onFirstPage = "onFirstPage"
            :onLastPage = "onLastPage"
          />
        </div>
      </div>
    </div>
    <modal :large="true" ref="deleteModal" :cancelClass="'none'" :okClass="'none'">
      <div slot="title">Do you want to delete {{ name }}?</div>
      <vuestic-alert type="danger">
        <span class="badge badge-pill badge-danger">Danger!</span>
        You will not be able to reverse this action!
      </vuestic-alert>
      <button class="btn btn-secondary btn-micro" @click="hideDeleteModal()">
        CANCEL
      </button>
      <button class="btn btn-danger btn-micro" @click="deleteObject()">
        DELETE
      </button>
    </modal>
  </div>
</template>

<script>
  import Modal from '../../../../vuestic-theme/vuestic-components/vuestic-modal/VuesticModal'
  import axios from 'axios'
  import store from '../../../../store'

  export default {
    name: 'table-body',
    components: {
      Modal
    },
    props: {
      listDefinition: {
        type: Object,
        default: () => {}
      },
      multiSelectAll: {
        type: Function
      },
      multiSelectCount: {
        type: Number
      },
      multiSelectChange: {
        type: Function
      },
      multiSelect: {
        type: Array
      },
      sortBy: {
        type: Function
      },
      sortOrders: {
        type: Object
      },
      sortKey: {
        type: String
      },
      displayData: {
        type: Array
      },
      search: {
        type: Array
      },
      option: {
        type: Array
      },
      filteredData: {
        type: Array
      },
      filteredObject: {
        type: Function
      },
      pageNo: {
        type: Number
      },
      perPage: {
        type: Number
      },
      perPageChange: {
        type: Function
      },
      onChangePage: {
        type: Function
      },
      onNextPage: {
        type: Function
      },
      onPreviousPage: {
        type: Function
      },
      onFirstPage: {
        type: Function
      },
      onLastPage: {
        type: Function
      },
      policy: {
        type: Function
      },
      client: {
        type: Object
      },
      objectEdit: {
        type: Boolean,
        default: true
      },
      objectDelete: {
        type: Boolean,
        default: true
      }
    },
    computed: {
      rows () {
        return this.displayData.length > 0
      }
    },
    data: function () {
      var tableFields = this.listDefinition.tableFields
      return {
        id: null,
        name: null,
        tableFields,
        tableLinks: this.listDefinition.tableLinks,
        bulkEdit: this.listDefinition.bulkEdit,
        list_urls: this.listDefinition.urls,
        textOptions: ['Starts with', 'Ends with', 'Contains', 'Exact match'],
        rangeOptions: ['==', '!=', '>', '<', '>=', '<=']
      }
    },
    methods: {
      showModal (name) {
        var self = this
        self.$refs[name][0].open() // $refs property name same as in ref="modal"
        self.openModal = name
      },
      ok () {
        var self = this
        self.filteredObject()
        self.$refs[self.openModal][0].cancel()
        self.openModal = ''
      },
      remove (id, name) {
        var self = this
        self.id = id
        self.name = name
        self.$refs.deleteModal.open()
      },
      hideDeleteModal () {
        this.$refs.deleteModal.cancel()
      },
      deleteObject () {
        store.commit('setLoading', true)
        const self = this
        self.$refs.deleteModal.cancel()
        const path = self.list_urls.deleteObject.url
        const id = self.id ? self.id : null
        const url = self.client.methods.api_url(path, id)
        let options = self.client.methods.api_options()
        axios[self.list_urls.deleteObject.method](url, options)
        .then(function (response) {
          store.commit('setLoading', false)
          self.$router.go('/')
        })
        .catch(function (error) {
          console.log(error)
          store.commit('setLoading', false)
          if (error.response.status === 401) {
            self.$router.push({ name: 'Logout' })
          }
        })
      }
    }
  }
</script>
<style lang="scss">
  @import "../../../../sass/variables";

  th.active{
  color: $fractel-teal;
  }

  th.active .arrow {
  opacity: 1;
  }

  .arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0;
  }

  .arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #000;
  }

  .arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #000;
  }

  .search-input {
    border: 1px solid black;
    border-radius: 5px;
  }

  .pagination-input {
    margin-left: 1em;
    border: 0.1em solid black;
    border-radius: 0.5em;
    max-width: 3.5em;
    line-height: 3em;
    text-align: center;
  }

  /* Vuestic Widget */
  .widget {
    background: $widget-bg;
    box-shadow: $widget-box-shadow;
    margin-bottom: $widget-mb;
    padding: 0;

    &.no-header {
      .widget-body {
        height: $widget-body-no-header-height;
      }
    }

    &.larger-padding {
      .widget-body {
        padding: $widget-larger-padding;
      }
    }

    &.no-h-padding {
      .widget-body {
        padding-left: 0;
        padding-right: 0;
      }
    }

    &.no-v-padding {
      .widget-body {
        padding-top: 0;
        padding-bottom: 0;
      }
    }

    &.brand-info {
      background-color: $brand-info;
      color: $white;
      box-shadow: $widget-info-shadow;
    }

    &.brand-danger {
      background-color: $brand-danger;
      color: $white;
      box-shadow: $widget-danger-shadow;
    }

    &.info-widget {
      border-top: $info-widget-border;

      &.brand-info {
        border-top-color: $brand-info;
      }

      &.brand-danger {
        border-top-color: $brand-danger;
      }
    }

    .widget-body {
      height: $widget-body-with-header-height;
      padding: $widget-padding;
    }

    .widget-header {
      height: $widget-header-height;
      padding: 0 $widget-padding;
      border-bottom: $widget-header-border;
      font-size: $font-size-larger;
      font-weight: 600;
      display: flex;
      align-items: center;
    }
  }

  .filter-input {
    border: 0.1em solid grey;
    border-radius: 0.25em;
  }
  .clear-filter:hover {
    color: $fractel-teal;
    text-decoration: underline;
    cursor: pointer;
  }

  .modal-table tbody {
    background-color: #FFFFFF !important;
    border-bottom: 0;
    font-size: $font-size-mini !important;
  }

  .modal-table tbody td{
    vertical-align: bottom !important;
  }

  .hover-text:hover {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/fractel/components/objects/table/Body.vue